import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import Media from "../../../components/Media/Media";

export default function P206Dialog({ submitForm, data, setData, dialog, setDialog }) {
    const [dataPic, setDataPic] = useState([]);

    useEffect(() => {
        // console.log('data ',data);
        setDataPic(data);
    }, [data]);

    const renderFooter = () => {
        return (
            <div style={{ textAlign: "right" }}>
                <Button label="บันทึก" icon="pi pi-save" onClick={() => submitForm(dataPic)} autoFocus className="p-button p-button-success" />
                <Button
                    label="ยกเลิก"
                    icon="pi pi-times"
                    onClick={() => {
                        setDialog({ dialog: false });
                    }}
                    className="p-button-danger p-button"
                />
            </div>
        );
    };

    const onInputTextChange = (e, key, id) => {
        const val = (e.target && e.target.value) || "";

        const newList = [...dataPic];
        const editIndex = newList.findIndex((item) => {
            return item.index === id;
        });
        //index item.inspectorUserId

        if (editIndex > -1) {
            let newData = newList[editIndex];

            if (e.checked) {
                newData = {
                    ...newData,
                    [`${key}`]: val,
                };
            } else {
                newData = {
                    ...newData,
                    [`${key}`]: "N",
                };
            }

            newList[editIndex] = newData;

            setDataPic(newList);
        }
    };

    const renderItem = () => {
        return dataPic.map((item, index) => {
            return (
                <div className="p-col-4">
                    <div className="card">
                        <div className="p-grid p-fluid">
                            <div className="p-col-12 p-md-5" style={{ display: "flex" }}>
                                {/* <img 
                                    alt={item.inspectorName} 
                                    {...srcPersonFile(item.profilePhotoPath)}
                                    //className="product-image"
                                    style={{ width: 78, height: 80,cursor:'pointer'}} 
                                    // onClick={toggle}
                                    
                                /> */}
                                <Media path={item.profilePhotoPath} alt={item.inspectorName} type="images" typefile="person" className="thumbnai-responsive" />
                            </div>
                            <div className="p-col-12 p-md-7">
                                <div style={{ marginLeft: 5 }}>
                                    <h5>{item.inspectorName}</h5>
                                    <br />
                                    <div className="p-field-checkbox">
                                        <Checkbox
                                            inputId={"selectFlag_" + index}
                                            name={"selectFlag_" + index}
                                            value="Y"
                                            // disabled = {data.commentTools === 'N'?false:true}
                                            checked={item.selectFlag === "Y" ? true : false}
                                            onChange={(e) => onInputTextChange(e, "selectFlag", item.index, item.inspectorUserId)}
                                            disabled={item.seqPk === 1 ? true : false}
                                        />
                                        <label htmlFor={"selectFlag_" + index}>ปฏิบัติงาน</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        });
    };

    return (
        <>
            <Dialog header="เลือก ผู้ปฏิบัติงาน" visible={dialog.dialog} style={{ width: "80vw" }} className="p-fluid ___widthDialog" footer={renderFooter()} onHide={() => setDialog(false)} blockScroll={true} className="p-fluid" maximizable={true}>
                {/* <div className="p-grid" style={{ marginBottom: 30 }}> */}
                <div className="p-grid crud-demo" style={{ marginBottom: 30 }}>
                    {dataPic && renderItem()}
                </div>
            </Dialog>
        </>
    );
}
